/*
 * @Author: your name
 * @Date: 2021-09-27 09:46:48
 * @LastEditTime: 2021-10-11 14:34:40
 * @LastEditors: Please set LastEditors
 * @Description: 订运单派车、委派页面计费规则相关接口
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\distributeCarOfFee.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_FINANCIAL_WEB } = e6ModuleOrderWaybillProcessApi;

// 派车页面选车之后获取费用设置
export function fetchFeeSettingByVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/assignVehicleFee`,
    method: "post",
    data
  });
}
//选中人工选择计费规则后获取对应计费规则下拉
export function fetchFeeRulesList(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/changeFee`,
    method: "post",
    data
  });
}
// 委派弹框选择承运商之后获取费用设置
export function fetchFeeSettingOfDelegate(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/delegateFee`,
    method: "post",
    data
  });
}
//津贴类型下拉数据
export function fetchAllowanceTypeData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowanceInfo/ruleDropBox`,
    method: "post",
    data
  });
}
// 费用保存接口
export function saveFeeSetting(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/financialFee/saveFee`,
    method: "post",
    data
  });
}
